import { render } from "./TeamComponent.vue?vue&type=template&id=7afac648"
import script from "./TeamComponent.vue?vue&type=script&lang=js"
export * from "./TeamComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\hhsiao\\Downloads\\Mamba\\cloud-business\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__